import {GoToCategory} from "../GoToItem";
import {useOfficeStore} from "../../../api/OfficeStore";
import {RemoteValue} from "../../../util/RemoteValue";
import {useGoToItems} from "./useGoToItems";
import {Offices_Read} from "../../../util/access/Permission";
import {OfficeIcon} from "../../office-icon/OfficeIcon";
import {buildOfficePathElement} from "../../../util/OfficePath";
import {replaceOfficePathPrefix} from "../../../api/CurrentOfficeStore";
import {useLocation} from "react-router-dom";
import {useAccess} from "../../../util/access/UseAccess";

export function useOfficeGoToItems(): RemoteValue<GoToCategory> {
    const access = useAccess();
    const offices = useOfficeStore(state => state.remoteValue);
    const location = useLocation();

    return useGoToItems(
        'Offices',
        [Offices_Read],
        offices,
        offices => offices
            .filter(office => !office.disabled)
            .filter(office => access.accessibleOffices.canAccessOffice(office.id))
            .map(office => ({
                id: `office-${office.id}`,
                label: office.name,
                sublabel: office.hibobResidence.map(mapping => [mapping.workSite?.name, mapping.hibobOffice?.name].filter(Boolean).join(' / ')).join(', ') || undefined,
                icon: () => <OfficeIcon office={office} colored fontSize="medium"/>,
                url: () => replaceOfficePathPrefix(location, buildOfficePathElement(office)),
            })),
    );
}
